const commaSeparetedValue = (value, fraction = 2) => parseFloat(value).toLocaleString(undefined, {
  minimumFractionDigits: fraction,
})

export default commaSeparetedValue
